import { computed } from '@angular/core';
import { withSessionStorage, withStorageSync } from '@angular-architects/ngrx-toolkit'; // docs: https://github.com/angular-architects/ngrx-toolkit
import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';

import { StoreStatus } from 'app/home/global-store/store-status.model';
import { userInitialState } from 'app/home/global-store/user/user-initial-state';
import { EntryType, UserState, UserType } from 'app/home/global-store/user/user.model';

/**
 * User Store
 * - this is provided in the orchestration component
 * Great Intro Post: https://offering.solutions/blog/articles/2023/12/03/ngrx-signal-store-getting-started/
 */
export const UserStore = signalStore(
  { providedIn: 'root' },
  withState(userInitialState),
  // Selectors
  withComputed((store) => ({
    isLoading: computed(() => store.storeStatus() === 'loading'),
    isError: computed(() => typeof store.storeStatus() === 'object'),
  })),
  withMethods((store) => ({
    reset(): void {
      patchState(store, () => userInitialState);
    },
    patchStore: (newState: Partial<UserState>) => {
      patchState(store, () => newState);
    },
    startQuoting: () => {
      patchState(store, () => ({ isQuoting: true }));
    },
    endQuoting: () => {
      patchState(store, () => ({ isQuoting: false }));
    },
    setEntryType: (entryType: EntryType | undefined) => {
      patchState(store, () => ({ entryType }));
    },
    setKinId: (kinId: number) => {
      patchState(store, () => ({ kinId }));
    },
    setKinPersonId: (kinPersonId: number) => {
      patchState(store, () => ({ kinPersonId }));
    },
    setKinSegmentId: (kinSegmentId: string) => {
      patchState(store, () => ({ kinSegmentId }));
    },
    setUserType: (userType: UserType) => {
      patchState(store, () => ({ userType }));
    },
    updateStatus: (status: StoreStatus) => {
      patchState(store, () => ({ storeStatus: status }));
    },
  })),
  withStorageSync(
    {
      key: 'user',
      autoSync: true,
    },
    withSessionStorage(),
  ),
);
